module.exports = __webpack_public_path__ + "static/media/mr-trufmos-bossa1.4709b40d.jpg";